export default __webpack_public_path__ + "static/media/citation.c05a5355.svg";